<template>
<div style="position:relative; overflow-x:hidden;"
     v-if="$parent.currentUser.adm_acc">
   <b-row style="border-top: solid 1px white;">
     <b-col>
       <span class="stat-section"> Aggregate Statistics </span>
       <span class="stat-loading" v-if="loading"
       >Loading {{ loading_percent }}% ...</span>
     </b-col> 
   </b-row>
   <b-row>
     <b-col sm="12">
      <b-button size="sm" class="stat_btn"
        @click="updateOlder"
        variant="primary">
        < 4 Hours Earlier
      </b-button>
      <b-form-select v-model="dateRange"
          @change="selectDateRange"
          style="width:fit-content;"
          :options="dateOptions"
          :select-size="1" size="sm">
      </b-form-select>
      <b-button size="sm" class="stat_btn"
        @click="updateToNow"
        variant="primary">
        Update to Now >
      </b-button>
     </b-col>
   </b-row>
   <b-row>
     <b-col sm="6">
       <input-sub ref="roomfilt-input" class="stat-roomfilt"
         v-model="roomfilt"
         v-on:enter='roomfilt_submit'
         v-on:key='roomfilt_key'
         placeholder="Room Filter"
       >
       </input-sub>
     </b-col>
     <b-col sm="2" style="padding-left:0">
       <b-button size="sm" class="stat_btn"
         @click="roomfilt_reset"
         variant="outline-danger">
         Reset
       </b-button>
     </b-col>
     <b-col sm="12" v-if="showAc">
       <span v-for="(ac) in acRooms">
         <span class="stat-acbtn"
           @click="selectAcRoom(ac)"
           variant="outline-primary">
           {{ ac }}
         </span>
       </span>
     </b-col>
   </b-row>
   <b-row>
     <b-col sm="11">
      <div class="stat_top" ref="stattop">
      </div>
     </b-col>
   </b-row>

   <b-row style="border-top: solid 1px white;">
     <b-col>
       <span class="stat-section"> Inspect Sessions </span>
     </b-col> 
   </b-row>
   <b-row>
     <b-col sm="11">
      <b-form-select v-model="sessKey"
          class="stat-sselect"
          @change="selectSessKey"
          :options="sessKeyOptions"
          :select-size="1" size="sm">
      </b-form-select>
     </b-col>
   </b-row>
   <b-row>
     <b-col sm="11">
        <b-table v-if="sessRows.length"
          style="margin:1rem;backgroundColor:white;"
          striped
          :items="sessRows"
          :fields="sessFields"
          small>
        </b-table>
     </b-col>
   </b-row>

</div>
</template>

<script>

import { MMSTATS } from "../stats";
import InputSub from "../components/InputSub";

export default {
  name: "StatViewer",
  components: {
    InputSub
  },
  watch: {
  },
  data() {
    return  {
      dateRange: ",now,0.5",
      dateOptions: [{text: "Last 12 Hours", value:",now,0.5"},
                    {text: "Last 24 Hours", value:",now,1"},
                    {text: "Last 2 Days", value:",now,2"},
                    {text: "Last 7 Days", value:",now,7"},
                   ],
      roomfilt: "",
      showAc: false,
      acRooms: [],
      loading: false,
      loading_percent: 0,
      sessKey: null,
      sessKeyOptions: [],
      sessRows:[],
      sessFields: [
       { key: "date", label:"" },
       { key: "name", label:"Event" },
       { key: "room", label:"Room" },
      ],
    };
  },
  computed: {
  },
  created() {
    let vue = this;
  },
  mounted() {
    let vue = this;
    let opt = {};
    if (!vue.$parent.currentUser.adm_acc) { return; }
    $("body").addClass("setbackground");
    opt.loading_cb = vue.loadingPercent;
    opt.update_cb = vue.dataUpdated;
    vue.stats = new MMSTATS(vx.slog, vx.acc, opt);
    if (vue.$refs.stattop) {
       vue.stats.attach(vue.$refs.stattop);
       vue.stats.selectDateRange(""+vue.dateRange);
    }
    $("body").css("background-color","white");
  },
  beforeDestroy() {
    let vue = this;
  },
  methods: {
    selectDateRange: function(ev) {
      let vue = this;
      console.log(vue.dateRange);
      vue.stats.selectDateRange(""+vue.dateRange);
    },
    updateOlder: function(ev) {
      let vue = this;
      vue.roomfilt = "";
      vue.stats.updateOlder(4);
    },
    updateToNow: function(ev) {
      let vue = this;
      vue.roomfilt = "";
      vue.stats.updateToNow(ev);
    },
    loadingPercent: function(p) {
      let vue = this;
      vue.loading = true;
      vue.loading_percent = p;
    },
    dataUpdated: function() {
      let vue = this;
      //console.log("dataUpdated");
      vue.loading = false;
      let sess = vue.stats.getSessions();
      sess = sess.sort(function(a,b) {
        if (a.key < b.key) { return -1; }
        if (a.key > b.key) { return 1; }
        return 0;
      });
      //console.log(vue.sess);
      if (!vue.roomfilt) {
        vue.sess = sess;
      } else {
        vue.sess = [];
        sess.forEach(function(s) {
          let found = false;
          for (let i=0; i<s.events.length; i++) {
             let ev = s.events[i];
             if (!ev.r) { continue; }
             if (ev.r.fn == vue.roomfilt) {
               found = true;
               break;
             }
          }
          if (found) {
            vue.sess.push(s);
          }
        });
      }

      vue.sessKeyOptions = [];
      vue.sess.forEach(function(s) {
         vue.sessKeyOptions.push({
           text: ""+s.key+" ("+s.events.length+")",
           value: s.key,
         });
      });
      
      /* Update Table Selection (or clear of no longer present) */
      vue.selectSessKey();
    },
    selectSessKey: function() {
      let vue = this;
      if (!vue.sessKey) { return; }
      for (let i=0; i<vue.sess.length; i++) {
        if (vue.sess[i].key == vue.sessKey) {
          vue.showSessKey(i);
          return;
        }
      }
      /* Not Found */
      vue.sessRows = [];
      vue.sessKey = "";
      console.log("not found");
    },
    showSessKey: function(idx) {
      let vue = this;
      let rows = [];
      console.log("Show Session",idx,vue.sess[idx]);
      for (let i=0; i<vue.sess[idx].events.length; i++) {
        let ev = vue.sess[idx].events[i];
        let name = ev.p+":"+ev.a;
        let room = "";
        let d = new Date(0);
        d.setUTCSeconds(ev.tm/1000);
        if (ev.r && ev.r.r) {
           room = ev.r.r;
        }
        switch(ev.p) {
        case "-":
          switch(ev.a) {
          case "cont": name = "continue"; break;
          case "loading": name = "site:load"; break;
          case "signout": name = "site:signout"; break;
          case "close": name = "site:close"; break;
          }
          break;
        case "login":
          break;
        case "guest":
          break;
        case "home":
          break;
        case "room":
          break;
        case "chat":
          break;
        case "cap":
          break;
        }
        let dstr = d.toISOString();
        dstr = dstr.replace("T",", ");
        dstr = dstr.split(".")[0];
        rows.push({
          date: dstr,
          name: name,
          room: room,
        });
      }
      vue.sessRows = rows;
    },
    roomfilt_submit: function(ev) {
      let vue = this;
      console.log(vue.roomfilt);
      vue.showAc = false;
      if (!vue.roomfilt) {
        vue.stats.showAll();
      } else {
        vue.stats.filterByRoom(""+vue.roomfilt);
      }
      vue.dataUpdated();
    },
    roomfilt_key: function(ev) {
      let vue = this;
      let rsp = vue.stats.acRoomName(""+vue.roomfilt);
      vue.acRooms = [];
      vue.showAc = true;
      rsp.forEach(function(rm) {
        vue.acRooms.push(rm);
      });
    },
    roomfilt_reset: function() {
      let vue = this;
      vue.showAc = false;
      vue.roomfilt = "";
      vue.stats.showAll();
      vue.dataUpdated();
    },
    selectAcRoom: function(name) {
      let vue = this;
      vue.showAc = false;
      vue.roomfilt = name;
      if (vue.$refs["roomfilt-input"]) {
        vue.$refs["roomfilt-input"].setfocus();
      }
      vue.stats.filterByRoom(""+vue.roomfilt);
      vue.dataUpdated();
    },
  },
}
</script>

<style lang="scss" scoped>

.stat-section {
  margin: 0.5rem 1rem;
  color:white;
}

.stat-loading {
  color: rgba(200,50,50,1);
}

.stat_btn {
  margin: 0 0.5rem;
  line-height: 1rem;
  font-size: 0.9rem;
}

.stat_top {
  height: 50vh;
}

.stat-acbtn {
 padding:0 0.3rem;
 margin:1px;
 font-size: 0.9rem;
 background: black;
 color:#007bff;
 border: 1px solid #007bff;
 border-radius: 5px;
 padding: 0.1rem 0.25rem;
}

.stat-acbtn:hover {
 background:#007bff;
 color:white;
}

.stat-roomfilt {
  max-width: 95%;
  margin: 0 0 0 0.5rem;
}

.stat-sselect {
  width:fit-content;
  margin: 0 0 0 0.5rem;
}
</style>